<div class="flex flex-column xl:flex-row">
  <!-- Main Content Area -->
  <div class="flex-1 xl:flex-none"
    [ngClass]="{ 'xl:w-9': cartStateService.canBeVisible(), 'xl:w-full': !cartStateService.canBeVisible() }">
    <ng-container>
      <app-authorized-header [header]="pageHeader" [subHeader]="subHeader">
      </app-authorized-header>
    </ng-container>

    <ng-container *ngIf="customer()">
      <app-order-menu class="flex flex-column" [customer]="customer()" [business]="business()"></app-order-menu>
    </ng-container>
    <div class="border-black-alpha-40 border-round-xl">
      <router-outlet></router-outlet>
    </div>
  </div>

  <!-- Cart (only if available) -->
  <div class="flex-none hidden xl:block xl:w-3 xl:ml-3" *ngIf="cartStateService.canBeVisible()">
    <app-order-cart class="flex flex-column"></app-order-cart>
  </div>
</div>

<div class="finalize-notice-dialog">
  <p-dialog [(visible)]="displayLeaveConfirmation" [modal]="true" [closable]="true" [draggable]="false"
    [resizable]="false" [style]="{ width: '456px', height: '200px' }" [contentStyle]="{ overflow: 'hidden' }"
    styleClass="border-round-2xl shadow-6 overflow-hidden" header="Leave Page?">
    <div class="flex flex-column justify-content-between h-full">
      <!-- Message -->
      <div class="text-900 text-sm line-height-3 font-medium font-semibold">
        If you navigate away from this page, all progress
        on your current order will be permanently lost.
      </div>

      <!-- Buttons -->
      <div class="flex justify-content-evenly align-items-center gap-3">
       
        <p-button label="STAY ON PAGE" [text]="true" (click)="stay()"></p-button>
        <button pButton type="button" label="" (click)="leave()"
          class="border-none border-round-2xl px-4 py-2 font-semibold bg-sara-negative-red">LEAVE ANYWAY</button>
      </div>

    </div>
  </p-dialog>
</div>